import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../components/api/axiosConfig';

const CookieBanner = () => {
    const { t } = useTranslation(['common']);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('sincroteam_cookie_consent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const submitConsentData = async (preferences) => {
        // Only trigger backend save if user is authenticated in Sincroteam
        const token = sessionStorage.getItem('access_token');
        if (token) {
            try {
                // Silently push the GDPR consent to the backend Profile model
                await axiosInstance.post('/api/privacy/consent/', {
                    cookie_preferences: preferences
                });
            } catch (err) {
                console.error("Errore salvataggio Privacy GDPR:", err);
            }
        }
    };

    const handleAccept = async () => {
        localStorage.setItem('sincroteam_cookie_consent', 'accepted');
        setIsVisible(false);
        await submitConsentData({
            necessary: true,
            analytics: true,
            marketing: true,
            preferences: true
        });
        // Here you would initialize your tracking scripts (GA, Pixel, etc.)
    };

    const handleDecline = async () => {
        localStorage.setItem('sincroteam_cookie_consent', 'declined');
        setIsVisible(false);
        await submitConsentData({
            necessary: true,
            analytics: false,
            marketing: false,
            preferences: false
        });
        // Ensure no tracking scripts are loaded
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 inset-x-0 pb-2 sm:pb-5 z-50">
            <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="p-4 bg-gray-900 rounded-lg shadow-xl border border-gray-700 sm:p-5 flex flex-col sm:flex-row items-center justify-between">
                    <div className="flex-1 flex items-center pr-4">
                        <span className="flex p-2 rounded-lg bg-blue-800">
                            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </span>
                        <p className="ml-3 font-medium text-white text-sm sm:text-base">
                            <span className="md:hidden">{t('cookie_banner.mobile_title', 'We use cookies.')}</span>
                            <span className="hidden md:inline">
                                {t('cookie_banner.description_start', 'Sincroteam uses cookies to guarantee the best platform experience and analyze traffic. Read our')} <Link to="/privacy" className="underline text-blue-400 hover:text-blue-300">{t('privacy_policy', 'Privacy Policy')}</Link> {t('and', 'and')} <Link to="/cookies" className="underline text-blue-400 hover:text-blue-300">{t('cookie_policy', 'Cookie Policy')}</Link>.
                            </span>
                        </p>
                    </div>
                    <div className="mt-4 sm:mt-0 flex shrink-0 space-x-3">
                        <button
                            onClick={handleDecline}
                            className="flex items-center justify-center px-4 py-2 border border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-300 bg-transparent hover:bg-gray-800 focus:outline-none"
                        >
                            {t('cookie_banner.decline', 'Decline All')}
                        </button>
                        <button
                            onClick={handleAccept}
                            className="flex items-center justify-center px-5 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                        >
                            {t('cookie_banner.accept', 'Accept Essential & Tracking')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
